interface Props {
  size?: number;
  color?: string;
}

const CalendarClockIcon = ({ size = 13, color = '#0A4DF2' }: Props) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5" />
    <path d="M16 2v4" />
    <path d="M8 2v4" />
    <path d="M3 10h5" />
    <circle cx="16" cy="16" r="6" />
    <path d="M16 14v2l1 1" />
  </svg>
);

export default CalendarClockIcon;
